export const JOB_TYPE = {
  requestAQuote: 'RequestAQuote',
  directMessage: 'DirectMessage',
} as const;

export type JobType =
  | (typeof JOB_TYPE)[keyof typeof JOB_TYPE]
  | 'post-a-job'
  | 'post-a-job-landing';

export const LEAD_STATUS = {
  submitted: 'Submitted',
  offered: 'Offered',
  accepted: 'Accepted',
  declined: 'Declined',
  redirected: 'Redirected',
} as const;

export const JOB_START_DATE = {
  asap: 'Asap',
  within2Weeks: 'Within2Weeks',
  within1Month: 'Within1Month',
  flexible: 'Flexible',
  inPlanning: 'InPlanning',
  urgent: 'Urgent',
  within1Week: 'Within1Week',
  withinFewDays: 'WithinFewDays',
  readyToBook: 'ReadyToBook',
} as const;

export const JOB_SEARCH_ALGORITHM = {
  raq: 'raq',
  ppcv3: 'ppcv3',
  raqLeadsRankingV23: 'RaqLeadsRankingV23',
} as const;
